import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Converts a "YYYY-MM-DD" string (interpreted in the user's local timezone)
 * into the UTC ISO string of the START of that day. Use with `.gte(...)` on
 * timestamptz columns to avoid the classic "filter by day X misses rows
 * created early in day X local time" bug.
 *
 * Example (Madrid CEST):
 *   localDateStartIso("2026-05-27") → "2026-05-26T22:00:00.000Z"
 */
export function localDateStartIso(yyyymmdd: string): string {
  return new Date(`${yyyymmdd}T00:00:00`).toISOString();
}

/** Same as localDateStartIso but for the END of the day (23:59:59.999 local). */
export function localDateEndIso(yyyymmdd: string): string {
  return new Date(`${yyyymmdd}T23:59:59.999`).toISOString();
}

/**
 * Combina el DÍA (calendario, zona local) de `day` con la HORA REAL actual y
 * devuelve el ISO UTC. Se usa al crear movimientos para guardar la hora exacta
 * de registro junto al día elegido (o la fecha del fichero importado), en lugar
 * de aplanar a una hora fija tipo 12:00. Como el día se toma en local y se
 * muestra en local, el día que ve el usuario se conserva.
 *
 * `day` puede ser un Date (sólo se leen Y/M/D) o un string "YYYY-MM-DD".
 */
export function dateWithCurrentTimeIso(day: Date | string): string {
  const now = new Date();
  let y: number, m: number, d: number;
  if (typeof day === "string") {
    const [ys, ms, ds] = day.split("-").map(Number);
    y = ys; m = (ms ?? 1) - 1; d = ds ?? 1;
  } else {
    y = day.getFullYear(); m = day.getMonth(); d = day.getDate();
  }
  return new Date(
    y, m, d,
    now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds()
  ).toISOString();
}
